"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.attrCreatApi = attrCreatApi;
exports.attrDeleteApi = attrDeleteApi;
exports.attrEditApi = attrEditApi;
exports.attrInfoApi = attrInfoApi;
exports.batchSetFicti = batchSetFicti;
exports.categoryApi = categoryApi;
exports.copyConfigApi = copyConfigApi;
exports.copyProductApi = copyProductApi;
exports.downloadDraftExcelTemplate = exports.deleteFictiTask = exports.deleteDraft = exports.createFictiTask = void 0;
exports.draftBoxData = draftBoxData;
exports.fictiTaskStop = exports.fictiTaskStart = exports.fictiTaskRun = void 0;
exports.getBarcodeInfo = getBarcodeInfo;
exports.getCommentSettingApi = getCommentSettingApi;
exports.getFictiTaskLog = exports.getFictiTaskList = void 0;
exports.guaranteeAddApi = guaranteeAddApi;
exports.guaranteeDelApi = guaranteeDelApi;
exports.guaranteeListApi = guaranteeListApi;
exports.guaranteeUpdateApi = guaranteeUpdateApi;
exports.guaranteeUpdateShowApi = guaranteeUpdateShowApi;
exports.importHistory = importHistory;
exports.importProductApi = importProductApi;
exports.offShellApi = offShellApi;
exports.orderExcelApi = orderExcelApi;
exports.productCreateApi = productCreateApi;
exports.productDeleteApi = productDeleteApi;
exports.productDetailApi = productDetailApi;
exports.productExcelApi = productExcelApi;
exports.productExportApi = productExportApi;
exports.productHeadersApi = productHeadersApi;
exports.productListbyidsApi = productListbyidsApi;
exports.productLstApi = productLstApi;
exports.productUpdateApi = productUpdateApi;
exports.putOnShellApi = putOnShellApi;
exports.replyCommentApi = replyCommentApi;
exports.replyCreatApi = replyCreatApi;
exports.replyDeleteApi = replyDeleteApi;
exports.replyEditApi = replyEditApi;
exports.replyInfoApi = replyInfoApi;
exports.replyListApi = replyListApi;
exports.restoreApi = restoreApi;
exports.saveDraft = void 0;
exports.setCommentSettingApi = setCommentSettingApi;
exports.stockAddApi = stockAddApi;
exports.templateListApi = templateListApi;
exports.uploadDraftExcel = exports.updateFictiTask = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 新增商品
 * @param pram
 */
function productCreateApi(data) {
  return (0, _request.default)({
    url: '/admin/store/product/save',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑商品
 * @param pram
 */
function productUpdateApi(data) {
  return (0, _request.default)({
    url: '/admin/store/product/update',
    method: 'POST',
    data: data
  });
}

/**
 * 批量设置虚拟销量
 * @param data
 */
function batchSetFicti(data) {
  return (0, _request.default)({
    url: '/admin/store/product/ficti',
    method: 'POST',
    data: data
  });
}

/**
 * 商品详情
 * @param pram
 */
function productDetailApi(id) {
  return (0, _request.default)({
    url: "/admin/store/product/info/".concat(id),
    method: 'GET'
  });
}

/**
 * 删除商品
 * @param pram
 */
function productDeleteApi(id, type) {
  return (0, _request.default)({
    url: "/admin/store/product/delete/".concat(id),
    method: 'get',
    params: {
      type: type
    }
  });
}

/**
 * 商品列表 表头数量
 */
function productHeadersApi(params) {
  return (0, _request.default)({
    url: '/admin/store/product/tabs/headers',
    method: 'GET',
    params: params
  });
}

/**
 * 商品列表
 * @param pram
 */
function productLstApi(params) {
  return (0, _request.default)({
    url: '/admin/store/product/list',
    method: 'GET',
    params: params
  });
}
/**
 * 商品分类
 * @param pram
 */
function categoryApi(params) {
  return (0, _request.default)({
    url: '/admin/category/list/tree',
    method: 'GET',
    params: params
  });
}
/**
 * 商品上架
 * @param pram
 */
function putOnShellApi(id) {
  return (0, _request.default)({
    url: "/admin/store/product/putOnShell/".concat(id),
    method: 'GET'
  });
}
/**
 * 商品下架
 * @param pram
 */
function offShellApi(id) {
  return (0, _request.default)({
    url: "/admin/store/product/offShell/".concat(id),
    method: 'GET'
  });
}
/**
 * 商品规格 列表
 * @param pram
 */
function templateListApi(params) {
  return (0, _request.default)({
    url: '/admin/store/product/rule/list',
    method: 'GET',
    params: params
  });
}
/**
 * 增加库存
 * @param pram
 */
function stockAddApi(data) {
  return (0, _request.default)({
    url: '/admin/store/product/quick/stock/add',
    method: 'POST',
    data: data
  });
}
/**
 * 商品规格 删除
 * @param pram
 */
function attrDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/store/product/rule/delete/".concat(id),
    method: 'get'
  });
}
/**
 * 商品规格 新增
 * @param pram
 */
function attrCreatApi(data) {
  return (0, _request.default)({
    url: '/admin/store/product/rule/save',
    method: 'POST',
    data: data
  });
}
/**
 * 商品规格 编辑
 * @param pram
 */
function attrEditApi(data) {
  return (0, _request.default)({
    url: '/admin/store/product/rule/update',
    method: 'POST',
    data: data
  });
}
/**
 * 商品规格 详情
 * @param pram
 */
function attrInfoApi(id) {
  return (0, _request.default)({
    url: "admin/store/product/rule/info/".concat(id),
    method: 'GET'
  });
}
/**
 * 商品评论 列表
 * @param pram
 */
function replyListApi(params) {
  return (0, _request.default)({
    url: '/admin/store/product/reply/list',
    method: 'GET',
    params: params
  });
}
/**
 * 商品评论 新增
 * @param pram
 */
function replyCreatApi(data) {
  return (0, _request.default)({
    url: '/admin/store/product/reply/save',
    method: 'POST',
    data: data
  });
}
/**
 * 商品评论 编辑
 * @param pram
 */
function replyEditApi(data) {
  return (0, _request.default)({
    url: '/admin/store/product/reply/update',
    method: 'POST',
    data: data
  });
}
/**
 * 商品评论 详情
 * @param pram
 */
function replyInfoApi(id) {
  return (0, _request.default)({
    url: "/admin/store/product/reply/info/".concat(id),
    method: 'GET'
  });
}
/**
 * 商品评论 删除
 * @param pram
 */
function replyDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/store/product/reply/delete/".concat(id),
    method: 'GET'
  });
}

/**
 * 商品评论 回复
 * @param pram
 */
function replyCommentApi(data) {
  return (0, _request.default)({
    url: "/admin/store/product/reply/comment",
    method: 'post',
    data: data
  });
}

/**
 * 商品评论 导出
 * @param pram
 */
function productExportApi(params) {
  return (0, _request.default)({
    url: "/admin/export/excel/product",
    method: 'get',
    params: params
  });
}

/**
 * 商品复制 99Api
 * @param pram
 */
function importProductApi(params) {
  return (0, _request.default)({
    url: "/admin/store/product/importProduct",
    method: 'post',
    params: params
  });
}

/**
 * 商品复制 一号通
 * @param pram
 */
function copyProductApi(data) {
  return (0, _request.default)({
    url: "/admin/store/product/copy/product",
    method: 'post',
    data: data
  });
}

/**
 * 恢复
 * @param pram
 */
function restoreApi(id) {
  return (0, _request.default)({
    url: "/admin/store/product/restore/".concat(id),
    method: 'get'
  });
}

/**
 * 商品列表 导出
 * @param pram
 */
function productExcelApi(params) {
  return (0, _request.default)({
    url: "/admin/export/excel/product",
    method: 'get',
    params: params
  });
}

/**
 * 商品列表 获取复制商品配置
 * @param pram
 */
function copyConfigApi() {
  return (0, _request.default)({
    url: "/admin/store/product/copy/config",
    method: 'post'
  });
}

/**
 * 订单数据 导出
 * @param pram
 */
function orderExcelApi(params) {
  return (0, _request.default)({
    url: "/admin/export/excel/order",
    method: 'get',
    params: params
  });
}
/**
 * 根据商品id集合查询商品列表
 * @param pram
 */
function productListbyidsApi(ids) {
  return (0, _request.default)({
    url: "/admin/store/product/listids/".concat(ids),
    method: 'get'
  });
}
/**
 * 保障服务列表
 */
function guaranteeListApi(params) {
  return (0, _request.default)({
    url: "/admin/store/product/guarantee/list",
    method: 'get',
    params: params
  });
}
/**
 * 保障服务添加
 */
function guaranteeAddApi(data) {
  return (0, _request.default)({
    url: "/admin/store/product/guarantee/add",
    method: 'post',
    data: data
  });
}
/**
 * 保障服务删除
 */
function guaranteeDelApi(id) {
  return (0, _request.default)({
    url: "/admin/store/product/guarantee/delete/".concat(id),
    method: 'post'
  });
}
/**
 * 保障服务修改
 */
function guaranteeUpdateApi(data) {
  return (0, _request.default)({
    url: "/admin/store/product/guarantee/update",
    method: 'post',
    data: data
  });
}
/**
 * 保障服务显示状态修改
 */
function guaranteeUpdateShowApi(id) {
  return (0, _request.default)({
    url: "/admin/store/product/guarantee/update/show/".concat(id),
    method: 'post'
  });
}
/**
 * 商品评论配置获取
 */
function getCommentSettingApi() {
  return (0, _request.default)({
    url: "/admin/store/product/reply/manage/get",
    method: 'get'
  });
}
/**
 * 商品评论配置提交
 */
function setCommentSettingApi(data) {
  return (0, _request.default)({
    url: "/admin/store/product/reply/manage/set",
    method: 'post',
    data: data
  });
}
/**
 * 扫码查询
 */
function getBarcodeInfo(code) {
  return (0, _request.default)({
    url: "/admin/barcode/info?barCode=".concat(code),
    method: 'get'
  });
}
/**
 * 虚拟销量任务列表
 * @param {Object} params 查询参数
 * @param {string} [params.name] 任务名称
 * @param {number} [params.status] 状态：0正常，1暂停
 * @param {number} [params.limit] 每页数量
 * @param {number} [params.page] 页码
 * @returns {Promise<object>}
 */
var getFictiTaskList = exports.getFictiTaskList = function getFictiTaskList(params) {
  return (0, _request.default)({
    url: '/admin/product/ficti/task/list',
    method: 'GET',
    params: params
  });
};

/**
 * 虚拟销量任务日志
 */
var getFictiTaskLog = exports.getFictiTaskLog = function getFictiTaskLog(params) {
  return (0, _request.default)({
    url: '/admin/product/ficti/task/log/list',
    method: 'GET',
    params: params
  });
};

/**
 * 新增虚拟销量任务
 */
var createFictiTask = exports.createFictiTask = function createFictiTask(data) {
  return (0, _request.default)({
    url: '/admin/product/ficti/task/save',
    method: 'POST',
    data: data
  });
};

/**
 * 编辑虚拟销量任务
 */
var updateFictiTask = exports.updateFictiTask = function updateFictiTask(data) {
  return (0, _request.default)({
    url: '/admin/product/ficti/task/update',
    method: 'POST',
    data: data
  });
};

/**
 * 启动虚拟销量任务
 */
var fictiTaskStart = exports.fictiTaskStart = function fictiTaskStart(id) {
  return (0, _request.default)({
    url: "/admin/product/ficti/task/start/".concat(id),
    method: 'POST'
  });
};

/**
 * 暂停虚拟销量任务
 */
var fictiTaskStop = exports.fictiTaskStop = function fictiTaskStop(id) {
  return (0, _request.default)({
    url: "/admin/product/ficti/task/stop/".concat(id),
    method: 'POST'
  });
};

/**
 * 立即执行虚拟销量任务
 */
var fictiTaskRun = exports.fictiTaskRun = function fictiTaskRun(id) {
  return (0, _request.default)({
    url: "/admin/product/ficti/task/run/".concat(id),
    method: 'POST'
  });
};

/**
 * 删除虚拟销量任务
 */
var deleteFictiTask = exports.deleteFictiTask = function deleteFictiTask(id) {
  return (0, _request.default)({
    url: "/admin/product/ficti/task/delete/".concat(id),
    method: 'POST'
  });
};
/**
 * 草稿列表
 */
function draftBoxData(params) {
  return (0, _request.default)({
    url: '',
    method: 'GET',
    params: params
  });
}
/**
 * 删除草稿
 */
var deleteDraft = exports.deleteDraft = function deleteDraft(ids) {
  return (0, _request.default)({
    url: "",
    method: 'POST'
  });
};
/**
 * 保存草稿
 */
var saveDraft = exports.saveDraft = function saveDraft(data) {
  return (0, _request.default)({
    url: '',
    method: 'POST',
    data: data
  });
};
/**
 * 导出批量草稿模版
 */
var downloadDraftExcelTemplate = exports.downloadDraftExcelTemplate = function downloadDraftExcelTemplate() {
  return (0, _request.default)({
    url: '/admin/store/product/import/template',
    method: 'get',
    responseType: 'blob'
  });
};

/**
 * 导入商品表格
 */
var uploadDraftExcel = exports.uploadDraftExcel = function uploadDraftExcel(data) {
  return (0, _request.default)({
    url: '/admin/store/product/import/submit',
    method: 'post',
    data: data
  });
};

/**
 * 导入记录
 */
function importHistory(params) {
  return (0, _request.default)({
    url: '/admin/store/product/import/task/list',
    method: 'GET',
    params: params
  });
}